import {
  Typography,
  Grid,
  withStyles,
  Theme,
  WithStyles,
  SnackbarContent,
} from '@material-ui/core';
import React, { useState } from 'react';
import { compose } from 'recompose';
import { withLocale } from '../../hocs/withLocale';
import { BookingTermsAndConditions } from './BookingTermsAndConditions';
import { serviceLocator } from '../../infrastructure/ServiceLocator';
import UserHelper from '../../infrastructure/UserHelper';
import { SignUpConfirmationButtons } from './SignUpConfirmationButtons';
import {Attendance, ClassInfo, Studio, User} from "../../types";


interface Course {
  repeatableEvent?: {
    beforeBookingText?: string;
  };
}

interface StyleProps extends WithStyles<typeof styles> {
  field: string;
  label: string;
  buttons: string;
}

interface AuthorizedBookingFormProps extends StyleProps {
  course?: Course;
  classInfo: ClassInfo;
  studio: Studio;
  user: User;
  owner: User;
  translate: (key: string) => string;
  onSuccess: (attendance: Attendance) => void;
  onFailure: (error: Error) => void;
}

const styles = (theme: Theme) => ({
  field: {
    display: 'flex',
    flexDirection: 'column',
    margin: `${theme.spacing(2)}px 0`,
  },
  label: {
    marginBottom: theme.spacing(1),
    position: 'relative',
    transform: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  buttons: {
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100%',
    },
  },
});

const AuthorizedBookingFormComponent = ({
                                          course,
                                          classInfo,
                                          studio,
                                          user,
                                          owner,
                                          classes,
                                          translate,
                                          onSuccess,
                                          onFailure,
                                        }: AuthorizedBookingFormProps) => {
  const [clientNote, setNote] = useState('');
  const [isSubmitting, setSubmitting] = useState(false);
  const [tcAccepted, setAccepted] = useState(false);
  const studioClient = UserHelper.getStudioClient(user, owner._id);

  const signUp = async () => {
    setSubmitting(true);
    try {
      const attendance = await serviceLocator.registrationApi.registerMeToClass(
        { clientNote },
        studio.id,
        classInfo.groupId
      );
      onSuccess(attendance);
    } catch (e) {
      onFailure(e as Error);
    }
    setSubmitting(false);
  };

  return (
    <Grid container direction="column">
      <Typography variant="subtitle1">{user.name}</Typography>
      {course?.repeatableEvent?.beforeBookingText && (
        <SnackbarContent
          style={{ margin: '5px 0px' }}
          message={
            <div
              dangerouslySetInnerHTML={{
                __html: course.repeatableEvent.beforeBookingText,
              }}
            />
          }
        />
      )}
      {!studioClient && (
        <BookingTermsAndConditions
          accepted={tcAccepted}
          onChange={setAccepted}
          owner={owner}
        />
      )}
      <div className={classes.buttons}>
        <SignUpConfirmationButtons
          disabled={isSubmitting || (!studioClient && !tcAccepted)}
          classInfo={classInfo}
          studioClient={studioClient}
          userId={user._id}
          owner={owner}
          course={course}
          onSignUp={signUp}
          studio={studio}
        />
      </div>
    </Grid>
  );
};

export const AuthorizedBookingForm = compose(
  withLocale,
  withStyles(styles)
)(AuthorizedBookingFormComponent);
